import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const addLinkSlice = createSlice({
  name: "addLink",
  initialState,
  reducers: {
    addLinkRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    addLinkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    addLinkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  addLinkRequested,
  addLinkRequestFailed,
  addLinkRequestSucceeded,
} = addLinkSlice.actions;

export default addLinkSlice.reducer;
